<div class="grid card-wrapper">
  <div class="md:col-5 sm:col-12">
    <div class="font-bold mt-2">{{ "taxo.selectCategory" | translate }}</div>
    <div class="pt-3">
      <p-treeSelect
        [showClear]="true"
        filterBy="categoryLabelLoc"
        [options]="categories"
        [(ngModel)]="selectedNode"
        (onNodeSelect)="onNodeSelect($event)"
        (onClear)="onClear()"
        placeholder="{{ 'global.selectItem' | translate }}">
        <ng-template let-node pTemplate="default">
          <div>
            <span>{{ node.categoryLabelLoc }}</span>
          </div>
        </ng-template>
      </p-treeSelect>
    </div>
    <div>
      <div style="min-height: calc(100vh - 400px)">
        @if (attributes?.length > 0) {
          <div class="font-bold mt-2 mt-3">
            {{ "taxo.searchAttribute" | translate }}
          </div>
          <p-tree
            #tree
            styleClass="noChildren"
            [style]="{ 'padding-right': '0' }"
            [scrollHeight]="'calc(100vh - 400px)'"
            [filter]="true"
            [filterBy]="'attributeName'"
            class="w-full"
            selectionMode="single"
            (onNodeSelect)="selectAttribute($event)"
            [value]="attributes">
            <ng-template let-node pTemplate="default">
              <div>
                <span class="p-ml-2">{{ node.attributeName }}</span>
              </div>
            </ng-template>
          </p-tree>
        }
      </div>
    </div>
  </div>
  <div class="md:col-7 sm:col-12">
    <div class="h-full">
      <div class="font-bold mt-2" style="margin-bottom: 13px">{{ "taxo.attributeInformation" | translate }}</div>
      <div class="h-full">
        @if (selectedAttribute) {
          <p-panel [toggleable]="true" class="w-full" class="mb-2">
            <ng-template pTemplate="header">
              <div class="flex gap-2 align-items-center">
                <span class="font-bold">{{ "taxo.generalInformation" | translate }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="body">
              <div class="grid p-3">
                <div class="col-6 font-semibold">{{'table.name' | translate}}</div>
                <div class="col-6">{{ selectedAttribute.attributeName }}</div>
                <div class="col-6 font-semibold">{{'table.TechnicalID' | translate}}</div>
                <div class="col-6">{{ selectedAttribute.attributeCode | translate }}</div>
                <div class="col-6 font-semibold">{{'table.type' | translate}}</div>
                <div class="col-6">{{ selectedAttribute.attributeType | translate }}</div>
                <div class="col-6 font-semibold">{{'table.localized' | translate}}</div>
                <div class="col-6">{{ selectedAttribute.localized }}</div>
                <div class="col-6 font-semibold">{{'table.distributionChannel' | translate}}</div>
                <div class="col-6">{{ selectedAttribute.channels?.join(", ") }}</div>
              </div>
            </ng-template>
          </p-panel>
          <div class="h-1rem"></div>
          @if(selectedAttribute.attributeRules?.length > 0) {
          <p-panel [toggleable]="true" class="w-full">
            <ng-template pTemplate="header">
              <div class="flex gap-2 align-items-center">
                <span class="font-bold">{{ "taxo.validationRules" | translate }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="body">
              <div class="grid p-3">
                @for (rule of selectedAttribute.attributeRules; track $index) {
                  <div class="col-6 font-semibold">{{ rule.type }}</div>
                  @if (rule.param2) {
                    <div class="col-3">{{ rule.param1 }}</div>
                    <div class="col-3">{{ rule.param2 }}</div>
                  } @else {
                    <div class="col-6">{{ rule.param1 }}</div>
                  }
                }
              </div>
            </ng-template>
          </p-panel>
        }
          <div class="h-1rem"></div>
          @if(selectedAttribute.lookupValues?.length > 0) {
            <p-panel [toggleable]="true" class="w-full">
              <ng-template pTemplate="header">
                <div class="flex gap-2 align-items-center">
                  <span class="font-bold">{{ "taxo.listValues" | translate }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="body">
                <div class="custom-grid">
                  <div class="grid p-3">
                    <div class="col-6 font-semibold">{{"global.codes" | translate}}</div>
                    <div class="col-6 font-semibold">{{"global.values" | translate}}</div>
                  </div>
                  <div class="grid p-3">
                    @for (value of selectedAttribute.lookupValues; track $index) {
                      <div class="col-6">{{ value.code }}</div>
                      <div class="col-6">{{ value.label }}</div>
                    }
                  </div>
                </div>
            
              </ng-template>
            </p-panel>
          }
        } @else {
          <div class="flex align-items-center justify-content-center h-full">
            <span class="text-color-secondary font-italic">{{ "taxo.noAttributeSelected" | translate }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
